import {CompactModal} from '../../../../../../../components/modal/compact-modal';
import {ModalProps} from '../../../../../../../components/modal/modal';

export function PlannerBaseModal(props: ModalProps) {
  return <CompactModal {...props} />;
}
